// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YuA5","right":"styles_right__2NRzc"};